const toJson = (item) => {
    return {
        code: item.code,
        message: item.message,
        data: item.data
    }
}


export const ResponseModel = {
    toJson
}
